export enum EventAction {
  WEBSITE_CLICK = 'website_click',
  WEBSITE_PLAY = 'website_play',
  WEBSITE_SHARE = 'website_share',
  WEBSITE_SEND = 'website_send'
}
